import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "purchase";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    // 根据单据号获取车辆快照信息
    async carDetail({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingCarInfo/SnapshotList?NumberOrder=${payload}`
      );
      return result.data;
    },
    //删除称重单记录

    async delStock(a, payload) {
      let result = await api.delete(`/api/Stock?NumberOrder=${payload}`);
      return result;
    },
    // 添加采购、销售
    async addSales({ commit }, payload) {
      var result = await api.post(`/api/Stock`, payload);
      return result.data;
    },
    // 修改
    async editSales({ commit }, payload) {
      var result = await api.put(
        `/api/Stock?NumberOrder=${payload.numericalOrder}`,
        payload.data
      );
      return result.data;
    },
    //
    async salesDetail({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/SingleReport?NumberOrder=${payload}`
      );
      return result.data;
    },
    // 采购、销售报表-列表
    async getPurchaseReportList({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 采购、销售订单
    async getPurchaseOrder({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/Detail?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 产品状态列表
    async getStatusList({ commit }, payload) {
      var result = await api.get(
        `/api/Stock/GetProductLevel?enterId=${payload}`
      );
      return result.data;
    },
    // 导出报表
    async exportReport({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/Export?${queryString.stringify(payload)}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
    // 获得销售统计报表
    async getSalesTotalReport({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/GetWeighingSalesStatisticsReport?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    // 获得销售统计报表
    async getpurseTotalReport({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/GetSummaryToPC?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    // 渔联交易通PC端采购销售明细表
    async getPurchaseSalesDetail({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/GetDetailToPC?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 渔联交易通获取销售人员
    async getSalePerson({ commit }, payload) {
      var result = await api.get(`/api/User/GetSalePerson`);
      return result.data;
    },
    //损益列表导出
    async lossExportReport({ commit }, payload) {
      var result = await api.get(
        `/api/GainsLoss/Export?${queryString.stringify(payload)}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
    //采购、销售明细报表导出
    async purchaseSalesExport({ commit }, payload) {
      var result = await api.get(
        `/api/TransactionReport/ExportDetailToPC?${queryString.stringify(
          payload
        )}`,
        {
          responseType: "blob", //设置接收类型，修复乱码
        }
      );
      return result;
    },
  },
});

export default moduleName;
